import { visit } from "turbolinks";
import consumer from "./consumer"

consumer.subscriptions.create("VisitChannel", {
  connected() {
    // Called when the subscription is ready for use on the server
  },
  
  disconnected() {
    // Called when the subscription has been terminated by the server
  },
  
  received(data) {
    var ShowLabel = data.statusLable
    
    // for frontDesk or backoofice page
    var tableColumn =document.getElementById(data.field+'_'+data.visit_id)
    if(tableColumn){
      if(data.value=='true'){
        var iconMarked = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" fill="green">'+'<path d="M0 0h24v24H0z" fill="none"/><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"/></svg>'+ShowLabel
        tableColumn.innerHTML=iconMarked
      }
      else{
        var iconMarked = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" width="18" height="18" fill="green"><path fill-rule="evenodd" d="m5.965 4.904 9.131 9.131a6.5 6.5 0 0 0-9.131-9.131Zm8.07 10.192L4.904 5.965a6.5 6.5 0 0 0 9.131 9.131ZM4.343 4.343a8 8 0 1 1 11.314 11.314A8 8 0 0 1 4.343 4.343Z" clip-rule="evenodd" /></svg>'+ShowLabel
        tableColumn.innerHTML=iconMarked
      }
    }
    var timecolumn = document.getElementById(data.visit_id)
    var visitColumn = document.getElementById('highlight_'+data.visit_id)      
    // Show Notification
    if(data.value=='true'){
      // for notification
      var notification = document.getElementById('real_time')
      var notificationText = document.getElementById('real_time_text')
      if(notification && data.patient_name && data.value=='true'){
        var msg = "<b>"+data.patient_name +"'s</b> Status "+ShowLabel
        notificationText.innerHTML=msg
        notification.classList.remove('hide')
        setTimeout(()=>{
          notification.classList.add('hide')
        },5000)
      }
      // for remove hightlight the time column
      if(timecolumn){
        timecolumn.classList=''
        timecolumn.classList.add("time_column");
      }
      // for add class remove_highlight in Status column
      if(visitColumn){
        visitColumn.classList=''
        visitColumn.classList.add("remove_highlight");
      }
    }
    else if(data.value=='false'){
      if(timecolumn){
        var checkinPlusTime=$('#checkinPlus_'+data.visit_id)[0]
        checkinPlusTime=checkinPlusTime.querySelector("time").textContent;
        var checkinPlusTime30=$('#checkinPlus30_'+data.visit_id)[0]
        checkinPlusTime30=checkinPlusTime30.querySelector("time").textContent;
        const date = new Date();
        const year = date.getFullYear() - 2000; // Assuming 'yy' format means 2-digit years represent years after 2000
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');
        const currentTime= `${year}:${month}:${day}:${hours}:${minutes}:${seconds}`;
        const currentDate = parseCustomDateFormat(currentTime);
        const checkinDate = parseCustomDateFormat(checkinPlusTime);
        const checkinDate30 = parseCustomDateFormat(checkinPlusTime30);
        timecolumn.classList=''
        timecolumn.classList.add("time_column");
        if(checkinDate<=currentDate ){
          if(checkinDate30<=currentDate){
            timecolumn.classList.add("red_class");
          }
          else{
            timecolumn.classList.add("highlight_class");
          }
        }
      }
      // for add class remove_highlight in Status column
      if(visitColumn){
        console.log('visitcolumn')
        visitColumn.classList=''
        visitColumn.classList.add("no_idea");
      }
    }

    // Date  format for camparison
    function parseCustomDateFormat(dateString) {
      const parts = dateString.split(':');
      const year = parseInt(parts[0]) + 2000; // Assuming 'yy' format means 2-digit years represent years after 2000
      const month = parseInt(parts[1]) - 1; // Month is zero-based in JavaScript Date
      const day = parseInt(parts[2])-1;
      const hours = parseInt(parts[3]);
      const minutes = parseInt(parts[4]);
      const seconds = parseInt(parts[5]);
      return new Date(year, month, day, hours, minutes, seconds);
    }
    // Called when there's incoming data on the websocket for this channel
  }
});
